import { DecoratorNode } from "lexical";
import React from "react";
import { PDFInputComp } from "./Comp";
import { nanoid } from "nanoid";

export class PDFInputNode extends DecoratorNode {

  static getType() {
    return "PDFInputNode";
  }

  static clone(node) {
    return new PDFInputNode({
      value: node.__value,
      files: node.__files,
      multiple: node.__multiple,
      id: node.__id,
      key: node.__key,
    });
  }

  static importJSON(serializedNode) {
    return $createPDFInputNode({
      value: serializedNode.value,
      multiple: serializedNode.multiple,
      id: serializedNode.id,
    });
  }

  exportJSON() {
    return {
      type: this.constructor.getType(),
      value: this.__value,
      multiple: this.__multiple,
      id: this.__id,
    };
  }

  constructor({ value, files, multiple, id, key }) {
    super(key);
    this.__value = value;
    this.__files = files;
    this.__multiple = multiple;
    this.__id = id || nanoid(6);
  }

  createDOM() {
    return document.createElement("div");
  }

  updateDOM() {
    return false;
  }

  onChange(editor, value) {
    editor.update(() => {
      const self = this.getWritable();
      self.__value = value;
      if (self.__files) {
        self.__files = undefined;
      }
    });
  }

  onRemove(editor) {
    editor.update(() => {
      this.remove();
    });
  }

  decorate(editor) {
    return (
      <PDFInputComp
        nodeKey={this.__key}
        id={this.__id}
        files={this.__files}
        value={this.__value}
        multiple={this.__multiple}
        onChange={(k, v) => this.onChange(editor, v)}
        onRemove={() => this.onRemove(editor)}
      />
    );
  }

  isInline(){ //somehow this is important so that if this block is at end of editor, and we do arrow down + enter, then a new line will be created. Else it will not.
    return false
  }

}

export function $createPDFInputNode({ value, files, multiple, id, key }) {
  return new PDFInputNode({ value, files, multiple, id, key });
}

export function $isPDFInputNode(node) {
  return node instanceof PDFInputNode;
}
